import { ClientDatePicker } from "../inputs/ClientDatePicker";
import { disableBackspace } from "../../lib/utils";
import { getDateFormat, formatDate } from "../../lib/fields/DateField";
export const DatePreview = ({
  update,
  default: defaultValue,
  guid,
  style,
  value = defaultValue,
  required,
  read_only,
  label,
  errors,
  onBlur
}) => {
  const dateFormat = getDateFormat(style);
  const defaultDate = formatDate(value, style);
  const updateDate = (date = value) => {
    update(date);
  };
  const datePickerProps = {
    guid: guid,
    className: `input-fields__input`,
    dateFormat: dateFormat,
    update: updateDate,
    defaultDate,
    required: required,
    readOnly: read_only,
    label: label,
    error: errors,
    errorText: errors,
    onBlur,
    onKeyDown: disableBackspace
  };
  return <div className={`foundry--input-fields user-form--input ${errors && 'foundry--field-error'}`}>
      <ClientDatePicker {...datePickerProps} />
    </div>;
};